<template>
  <div v-if="userData.userData">
    <Layout :removePadding="true">
      <p class="heading font-weight-regular primary--text text-center">
        {{ $t("qr_view.qr_text") }}
      </p>

      <!--Temporarily disabled-->
      <!--v-row justify="center" v-if="showQR" class="mt-2">
        <v-progress-circular
          :indeterminate="!countdown"
          :size="50"
          :width="5"
          :rotate="-90"
          :value="getValue()"
          color="primary"
        >
          {{ countdown }}
        </v-progress-circular>
      </v-row-->

      <!--Static QR. Temporarily enabled-->
      <v-row justify="center">
        <v-col cols="12" class="d-flex justify-center ma-10">
          <div :style="$vuetify.breakpoint.width > 400 ? cssProps : ''">
            <qr-code
              class="qr-code"
              :text="userData.userData.id"
              :size="300"
              error-level="H"
              bg-color="#ffffff00"
              :color="'#0C0C0C'"
            ></qr-code>
          </div>
        </v-col>
      </v-row>

      <!--Temporarily disabled-->
      <!--v-row justify="center">
        <v-col cols="12" class="d-flex justify-center ma-10">
          <div :style="$vuetify.breakpoint.width > 400 ? cssProps : ''">
            <qr-code
              v-if="showQR && encodedJwt"
              class="qr-code"
              :text="encodedJwt"
              :size="qrSize"
              error-level="H"
              bg-color="#ffffff00"
              :color="'#0C0C0C'"
            ></qr-code>
            <v-progress-circular
              v-if="!showQR"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
      </v-row-->
      <v-row justify="center" class="mb-6">
        <v-col cols="auto">
          <v-btn
            :dark="$store.getters.themeOnSecondary === 'dark'"
            :light="$store.getters.themeOnSecondary === 'light'"
            color="primary"
            class="px-13 py-9"
            x-large
            rounded
            outlined
            outlined-border-width="7"
            @click="$router.push({ name: routeNames.WALLET })"
          >
            {{ $t("qr_view.dismiss_text") }}
          </v-btn>
        </v-col>
      </v-row>
    </Layout>
  </div>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { mapState } from "vuex";
import { RequestService } from "../services/request.service";
import jwt from "jsonwebtoken";
import routeNames from "@/router/route-names";

const requestService = new RequestService();
export default {
  data() {
    return {
      qrSize: 330,
      countdown: 60,
      intervalId: null,
      totalTime: 60,
      showQR: false,
      encodedJwt: null,
      routeNames: routeNames,
    };
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState(["userData"]),
    cssProps() {
      return {
        backgroundImage:
          "url(" + require("@/assets/images/qr_background.png") + ")",
        width: `${this.qrSize + 70}px`,
        height: `${this.qrSize + 70}px`,
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };
    },
  },
  methods: {
    getValue() {
      return (this.countdown * 100) / this.totalTime;
    },
    encodeJWT() {
      // Temporarily not in use
      const now = window.moment();
      const futureDate = now.add(1, "minutes");
      const exp = futureDate.unix();

      const payload = {
        sub: this.userData.userData.id,
        exp: exp,
      };

      this.encodedJwt = jwt.sign(payload, this.userData.userData.public_seed);
    },
    startCountdown() {
      this.intervalId = setInterval(async () => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.showQR = false;
          const context = this;
          clearInterval(this.intervalId);
          await requestService.getUserData(context);
          // await this.encodeJWT();
          // this.countdown = this.totalTime;
          // this.showQR = true;
          // this.startCountdown();
        }
      }, 1000);
    },
  },
  async mounted() {
    const context = this;
    await requestService.getUserData(context);
    // this.showQR = true;
    // await this.encodeJWT();
    // this.startCountdown();
  },
  beforeUnmount() {
    // clearInterval(this.intervalId);
  },
};
</script>
